<script lang="ts">
    // @ts-ignore
    import dayjs from "dayjs";
    import {
        S3Client,
        AbortMultipartUploadCommand,
        ListBucketsCommand,
        ListObjectsCommand,
        UploadPartCommand,
        PutObjectCommand,
    } from "@aws-sdk/client-s3";
    import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import { contentStore } from "../../../../store/contents";
    import { campaignWrapperStore } from "../../../../store/campaignWrappers";
    import type {
        ContentListEntry,
        PlayerListEntry,
    } from "../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { LocalDateTimeFormat } from "../../../../settings/settings";
    import { user } from "../../../../store/stores";
    import CampaignGeoSelect from "./Components/CampaignGeoSelect.svelte";
    import CampaignStationList from "./Components/CampaignLocationList.svelte";
    import TimeSlotTable from "./Components/NewCampaignTimeslotTable.svelte";
    import ContentCard from "./Components/ContentCard.svelte";
    import CampaignItem from "./Components/CampaignItem.svelte";
    import { DayOfWeek } from "../../../../../admin-service-typescript-client/admin-service-typescript-client";

    const baseCampaign = {
        name: "",
        duration: {
            start: dayjs().format(LocalDateTimeFormat),
            end: dayjs().add(1, "day").format(LocalDateTimeFormat),
            timeZone: "Europe/Berlin",
        },
        active: false,
        targetPlayers: [],
        contents: [],
        timePlan: [],
    };

    export let id;

    const navigate = useNavigate();
    let newContentModalOpen = false;
    let newContentUrl = "";
    let newContentName = "";
    let showCampaignWrapperNameInput = false;
    let graphLabels: string[] = [];
    let iconAsc = "↑";
    let iconDesc = "↓";
    let sortBy = "id";
    let sortOrder = 1;
    let rows = [];
    let loading = true;
    let searchObject: { [key: string]: any } = { creativeId: "" };
    let contentArray: ContentListEntry[] = [];
    let files;
    let client: S3Client;
    let uploading = false;
    let message = "";

    let selectedContentIds = [];
    let selectedPlayerIds = [];
    let timeTable = [];

    let step = 1;

    let campaignWrapperName = "";
    let campaigns: {
        name: string;
        duration: {
            start: string;
            end: string;
            timeZone: string;
        };
        active: boolean;
        contents: string[];
        timePlan: {
            dayOfWeek: DayOfWeek;
            from: string;
            to: string;
        }[];
        targetPlayers: string[];
    }[] = [baseCampaign];
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";

    const getCampaignWrapper = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .campaignWrapperClient.getCampaignWrapper({
                    campaignWrapperId: id,
                })
                .then((wrapper) => {
                    campaignWrapperStore.update((campaignWrapperStore) => {
                        return {
                            ...campaignWrapperStore,
                            campaignWrapper: wrapper,
                        };
                    });
                    return wrapper;
                })
                .then(console.log);
        });
    };

    // const updateWrapper = async () => {
    //         await $user.updateToken().then(async () => {
    //             const updateOrga = organisationDetails;
    //             await ApiClient.getInstance($user)
    //                 .organisationClient.updateOrganisation({
    //                     authorization: $user.token,
    //                     organisationId: organisationDetails.id,
    //                     organisationRequest: {
    //                         ...organisationDetails,
    //                         active: organisationDetails.active,
    //                     },
    //                 })
    //                 .then((orga) =>
    //                     organisationStore.update((organisationStore) => {
    //                         organisationDetails = { ...orga };
    //                         return {
    //                             ...organisationStore,
    //                             organisation: { ...orga },
    //                         };
    //                     })
    //                 )
    //                 .catch((err) => alert(err));
    //         });
    //     };

    onMount(() => {
        if (id) {
            getCampaignWrapper();
        }
    });

    const addNewCampaignItem = () => {
        campaigns = [...campaigns, { ...baseCampaign }];
    };

    const createNewCampaignWrapper = async () => {
        if (campaignWrapperName && campaignWrapperName !== "") {
            await $user.updateToken().then(async () => {
                console.log(campaigns);
                const campaignIds = await Promise.all(
                    campaigns.map(async (campaign) => {
                        const campaignResp = await createNewCampaign(campaign);
                        if (campaignResp) {
                            return campaignResp.id;
                        }
                    })
                );
                console.log(campaignIds);
                ApiClient.getInstance()
                    .campaignWrapperClient.createCampaignWrapper({
                        campaignWrapperRequest: {
                            name: campaignWrapperName,
                            campaigns: campaignIds,
                        },
                    })
                    .then(() => {
                        fetching = false;
                        status = true;
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
            return;
        }
        alert("Kein Kampagnenname vergeben");
    };

    const createNewCampaign = async (campaign) => {
        if (campaign.name && campaign.name !== "") {
            return await $user.updateToken().then(async () => {
                return ApiClient.getInstance()
                    .campaignClient.createCampaign({
                        campaignRequest: {
                            name: campaign.name,
                            duration: campaign.duration,
                            active: campaign.active,
                            contents: campaign.contents,
                            timePlan: campaign.timePlan,
                            targetPlayers: campaign.targetPlayers.map(
                                (player) => player.id
                            ),
                        },
                    })
                    .then((resp) => {
                        fetching = false;
                        status = true;
                        return resp;
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
            return;
        }
        alert("Kein Kampagnenname vergeben");
    };
</script>

<div class="columns">
    <div class="column is-12">
        <div class="card">
            <header class="card-header gradient-left">
                <p
                    class="card-header-title c-pointer f-white"
                    on:click={() => (showCampaignWrapperNameInput = true)}
                >
                    {#if !showCampaignWrapperNameInput}
                        {campaignWrapperName
                            ? campaignWrapperName
                            : "Kampagnenname..."}
                    {:else}
                        <form
                            on:submit|preventDefault={() =>
                                (showCampaignWrapperNameInput = false)}
                        >
                            <input
                                class="f-white b-seethrough"
                                bind:value={campaignWrapperName}
                                placeholder="Kampagnenname"
                            />
                        </form>
                    {/if}
                </p>
            </header>
            <div class="card-content">
                <div class="content">
                    <div class="columns is-multiline">
                        {#each campaigns as campaign, index}
                            <div class="column is-12">
                                <CampaignItem
                                    {campaign}
                                    {index}
                                    changeCampaignHandler={() => null}
                                    newCampaignItemhandler={addNewCampaignItem}
                                />
                            </div>
                        {/each}
                        <div class="column is-12">
                            <div
                                class="field is-grouped is-flex is-justify-content-space-between"
                            >
                                <div class="control">
                                    <button
                                        class="button gradient-left is-light"
                                        on:click={() => (step = 2)}
                                        >Zurück</button
                                    >
                                </div>
                                <div class="control">
                                    <button
                                        class="button gradient-left is-link {fetching
                                            ? 'is-loading'
                                            : ''}"
                                        on:click={() =>
                                            createNewCampaignWrapper()}
                                        >Erstellen</button
                                    >
                                </div>
                            </div>
                        </div>

                        <!--<section class="mui-1mmxj7b">
                        <span style="font-size: 0px;" />
                        <div
                            class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-direction-xs-column MuiGrid-wrap-xs-nowrap mui-129o4pc"
                        >
                            <div
                                class="MuiGrid-root MuiGrid-container MuiGrid-item mui-ja9bxb"
                            >
                                <div
                                    class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                >
                                    <h6
                                        class="MuiTypography-root MuiTypography-h6 mui-1y6miyj"
                                    >
                                        Creatives
                                    </h6>
                                </div>
                                <div
                                    class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                >
                                    <button
                                        class="MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButtonBase-root  mui-p0wysb"
                                        tabindex="0"
                                        type="button"
                                        >Select<span
                                            class="MuiTouchRipple-root mui-w0pj6f"
                                        /></button
                                    >
                                </div>
                            </div>
                            <div
                                class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                            />
                            <div
                                class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                            >
                                <div
                                    class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-4 mui-1tz8m30"
                                >
                                    <div
                                        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                                    >
                                        <div
                                            class="MuiGrid-root MuiGrid-container mui-1b1jvye"
                                        >
                                            <h6
                                                class="MuiTypography-root MuiTypography-subtitle2 mui-oc6lw9"
                                            >
                                                Landscape
                                            </h6>
                                            <div
                                                class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                            >
                                                <div
                                                    class="MuiGrid-root MuiGrid-container MuiGrid-item mui-n6nfem"
                                                >
                                                    <div
                                                        class="MuiFormGroup-root mui-1h7anqn"
                                                    >
                                                        <label
                                                            class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd mui-1jaw3da"
                                                            ><span
                                                                aria-label="Note: This is an experimental feature, which is still in testing phase and will not run yet on all screens in the network. Please contact support@framen.io for further details."
                                                                class=""
                                                                ><span
                                                                    class="MuiSwitch-root MuiSwitch-sizeSmall mui-vd1cxy"
                                                                    ><span
                                                                        class="MuiSwitch-switchBase MuiSwitch-colorPrimary MuiButtonBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary PrivateSwitchBase-root mui-1wiewz5"
                                                                        ><input
                                                                            class="MuiSwitch-input PrivateSwitchBase-input mui-1m9pwf3"
                                                                            type="checkbox"
                                                                        /><span
                                                                            class="MuiSwitch-thumb mui-19gndve"
                                                                        /><span
                                                                            class="MuiTouchRipple-root mui-w0pj6f"
                                                                        /></span
                                                                    ><span
                                                                        class="MuiSwitch-track mui-1ju1kxc"
                                                                    /></span
                                                                ></span
                                                            >
                                                            <p
                                                                class="MuiTypography-root MuiTypography-body2 mui-8294h9"
                                                            >
                                                                QR Code
                                                            </p></label
                                                        >
                                                    </div>
                                                    <button
                                                        class="MuiButtonBase-root Mui-disabled MuiIconButton-root Mui-disabled MuiIconButton-sizeLarge mui-1w8s6so"
                                                        tabindex="-1"
                                                        type="button"
                                                        disabled=""
                                                        ><svg
                                                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-vubbuv"
                                                            focusable="false"
                                                            aria-hidden="true"
                                                            viewBox="0 0 24 24"
                                                            data-testid="SettingsIcon"
                                                            ><path
                                                                d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                                                            /></svg
                                                        ></button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="MuiBox-root mui-19mxx9t">
                                            <div
                                                class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiAlert-root MuiAlert-outlinedWarning MuiAlert-outlined mui-1pw8y72"
                                                role="alert"
                                            >
                                                <div
                                                    class="MuiAlert-icon mui-1l54tgj"
                                                >
                                                    <svg
                                                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit mui-1cw4hi4"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 24 24"
                                                        data-testid="ReportProblemOutlinedIcon"
                                                        ><path
                                                            d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                                                        /></svg
                                                    >
                                                </div>
                                                <div
                                                    class="MuiAlert-message mui-1w0ym84"
                                                >
                                                    You have no creatives
                                                    selected. Please upload your
                                                    content to get started.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                                    >
                                        <div
                                            class="MuiGrid-root MuiGrid-container mui-1b1jvye"
                                        >
                                            <h6
                                                class="MuiTypography-root MuiTypography-subtitle2 mui-oc6lw9"
                                            >
                                                Portrait
                                            </h6>
                                            <div
                                                class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                            >
                                                <div
                                                    class="MuiGrid-root MuiGrid-container MuiGrid-item mui-n6nfem"
                                                >
                                                    <div
                                                        class="MuiFormGroup-root mui-1h7anqn"
                                                    >
                                                        <label
                                                            class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd mui-1jaw3da"
                                                            ><span
                                                                aria-label="Note: This is an experimental feature, which is still in testing phase and will not run yet on all screens in the network. Please contact support@framen.io for further details."
                                                                class=""
                                                                ><span
                                                                    class="MuiSwitch-root MuiSwitch-sizeSmall mui-vd1cxy"
                                                                    ><span
                                                                        class="MuiSwitch-switchBase MuiSwitch-colorPrimary MuiButtonBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary PrivateSwitchBase-root mui-1wiewz5"
                                                                        ><input
                                                                            class="MuiSwitch-input PrivateSwitchBase-input mui-1m9pwf3"
                                                                            type="checkbox"
                                                                        /><span
                                                                            class="MuiSwitch-thumb mui-19gndve"
                                                                        /><span
                                                                            class="MuiTouchRipple-root mui-w0pj6f"
                                                                        /></span
                                                                    ><span
                                                                        class="MuiSwitch-track mui-1ju1kxc"
                                                                    /></span
                                                                ></span
                                                            >
                                                            <p
                                                                class="MuiTypography-root MuiTypography-body2 mui-8294h9"
                                                            >
                                                                QR Code
                                                            </p></label
                                                        >
                                                    </div>
                                                    <button
                                                        class="MuiButtonBase-root Mui-disabled MuiIconButton-root Mui-disabled MuiIconButton-sizeLarge mui-1w8s6so"
                                                        tabindex="-1"
                                                        type="button"
                                                        disabled
                                                        ><svg
                                                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-vubbuv"
                                                            focusable="false"
                                                            aria-hidden="true"
                                                            viewBox="0 0 24 24"
                                                            data-testid="SettingsIcon"
                                                            ><path
                                                                d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                                                            /></svg
                                                        ></button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="MuiBox-root mui-19mxx9t">
                                            <div
                                                class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiAlert-root MuiAlert-outlinedWarning MuiAlert-outlined mui-1pw8y72"
                                                role="alert"
                                            >
                                                <div
                                                    class="MuiAlert-icon mui-1l54tgj"
                                                >
                                                    <svg
                                                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit mui-1cw4hi4"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 24 24"
                                                        data-testid="ReportProblemOutlinedIcon"
                                                        ><path
                                                            d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                                                        /></svg
                                                    >
                                                </div>
                                                <div
                                                    class="MuiAlert-message mui-1w0ym84"
                                                >
                                                    You have no creatives
                                                    selected. Please upload your
                                                    content to get started.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .field-name {
        text-align: left;
    }
    .container {
        height: calc(90vh - 30px);
    }
    .what {
        font-weight: 700;
        font-size: 1.7rem;
        padding-bottom: 2rem;
    }

    select {
        background-image: linear-gradient(
            to right,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        ) !important;
        color: white !important;
    }

    ::after {
        border-color: white !important;
    }

    /* .card {
        border-radius: 100px;
        padding: 2rem 4rem;
    } */

    .label {
        text-align: left;
        font-weight: 600 !important;
        font-size: 1.3rem;
        padding-top: 0.375rem;
    }

    .field-label {
        flex-grow: 1.5 !important;
    }

    .greenish {
        text-align: center;
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        text-align: center;
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }

    .c-pointer {
        cursor: pointer;
    }

    .gradient-left {
        background-image: linear-gradient(
            to right,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        ) !important;
        color: white !important;
    }

    .f-white {
        color: white !important;
    }
    .b-seethrough {
        background-color: transparent !important;
    }
</style>
